import React from "react";
import Box from "../../box/Box";
import { RadioButton } from "../../form/toggle/RadioGroup";
import Text from "../../text/Text";
import SubscriptionInfoModal from "../shared/SubscriptionInfoModal";
import CostPerServing from "../shared/CostPerServing";
import CostPerCount from "../shared/CostPerCount";
import { ProductCategory } from "../../@types/enums/ProductCategory";
import { PromoDiscountTypeEnum } from "onnit-ui/lib/@types/interfaces/PromoDiscountConfig";
import { getActivePromoDiscountConfig } from "onnit-ui/lib/buybox/shared/PromoDiscount";
import { RiskFreeLinkText } from "onnit-ui/lib/buybox/shared/RiskFreeLinkText";
var SubscriptionRadioButton = function (_a) {
    var _b, _c, _d;
    var product = _a.product, promoDiscountConfigs = _a.promoDiscountConfigs, freeShippingThreshold = _a.freeShippingThreshold;
    var isOnSale = product.sale_discount_ratio > 0;
    var saleText = isOnSale ? "".concat((product.sale_discount_ratio * 100).toFixed(), "% off") : "";
    var activePromoConfig = promoDiscountConfigs
        ? getActivePromoDiscountConfig(product.id, promoDiscountConfigs)
        : null;
    var subscriptionEligible = (_b = product.meta["subscription-eligible"] === "yes") !== null && _b !== void 0 ? _b : false;
    var subscriptionPrice = product.price_subscription_raw || 0.0;
    var subscriptionPercentOff = 15;
    var subscriptionRebillDiscountPercentOff = 15;
    var subscriptionInterval = (parseInt(product.meta["default-subscription-frequency"]) || 30) / 30;
    var subscriptionMonthlyIntervalText = "Deliver every ".concat(subscriptionInterval, " month").concat(subscriptionInterval > 1 ? 's' : '');
    if ((activePromoConfig === null || activePromoConfig === void 0 ? void 0 : activePromoConfig.promo_discounts_type) === PromoDiscountTypeEnum.SUBSCRIPTION) {
        subscriptionPrice = (1 - activePromoConfig.unit_discount_ratio) * parseFloat(product.price_msrp_raw);
        subscriptionPercentOff = activePromoConfig.unit_discount_ratio * 100;
        if (activePromoConfig.subscription_rebill_discount_ratio) {
            subscriptionRebillDiscountPercentOff = activePromoConfig.subscription_rebill_discount_ratio * 100;
        }
    }
    var isSupplementsOrFoods = product.meta.category === ProductCategory.FOODS ||
        product.meta.category === ProductCategory.SUPPLEMENTS;
    if (!subscriptionEligible) {
        return null;
    }
    return (React.createElement(RadioButton, { value: product.id },
        parseInt(product.meta["default-subscription-frequency"]) >= 30 && (React.createElement(Text, { color: "grays.4", display: "block" }, subscriptionMonthlyIntervalText)),
        React.createElement(Box, { display: "flex", alignItems: "center", mb: 1 },
            React.createElement(Text, { color: "grays.4" }, product.name),
            React.createElement(SubscriptionInfoModal, null)),
        React.createElement(RiskFreeLinkText, null),
        React.createElement("p", { className: "sr-only" }, "Normally,"),
        React.createElement(Text, { display: "inline-block", textDecoration: "line-through", color: "grays.4" }, product.price_msrp),
        React.createElement("p", { className: "sr-only" }, "Your price today,"),
        React.createElement(Text, { display: "inline-block", fontWeight: "bold", ml: 1 },
            "$",
            subscriptionPrice.toFixed(2)),
        React.createElement(Text, { display: "inline-block", fontWeight: "bold", color: "grays.4", ml: 2 }, product.is_subscription_discount_applicable
            ? "".concat(subscriptionPercentOff, "% off")
            : saleText),
        !product.is_subscription_discount_applicable && (React.createElement(Text, { display: "block", fontSize: 0, color: "grays.4", mt: 1 },
            "Subscription rebills at ",
            subscriptionRebillDiscountPercentOff,
            "% off MSRP")),
        parseFloat(product.price_raw) >= freeShippingThreshold
            ?
                (React.createElement(Text, { display: "block", fontSize: 0, color: "grays.4", mt: 1 }, "Free Shipping!")) : null,
        isSupplementsOrFoods && (React.createElement(React.Fragment, null,
            React.createElement(CostPerServing, { price: (_c = product.price_subscription_raw) === null || _c === void 0 ? void 0 : _c.toString(), totalServings: product.product_servings_total, display: "none", mt: 1 }),
            React.createElement(CostPerCount, { price: (_d = product.price_subscription_raw) === null || _d === void 0 ? void 0 : _d.toString(), count: product.product_size, unitOfMeasure: product.product_serving_unit_of_measure, display: "none", mt: 1 })))));
};
export default SubscriptionRadioButton;
//# sourceMappingURL=SubscriptionRadioButton.js.map